import { eventTracker } from "@/app/types"
import { Button } from "@/components/buttons/button"
import { Printer } from "@phosphor-icons/react"
import { useRouter } from "next/router"
import { useEffect } from "react"

const ROUTES_SHOWN = [
  "charts",
  "overview",
  "dashboard",
  "graffy",
  "pulse",
  "monitor",
  "grow",
]

const SINGLE_PAGE_ROUTES = ["monitor", "grow"]

export function PrintButton() {
  const { pathname } = useRouter()

  function handlePrint() {
    const currentRoute = pathname.split("/")[1]
    const isSinglePageRoute = SINGLE_PAGE_ROUTES.includes(currentRoute)

    if (isSinglePageRoute) {
      document.documentElement.style.overflow = "hidden"
      document.body.style.overflow = "hidden"
    }

    window.print()

    // clean up after print dialog closes
    setTimeout(() => {
      if (isSinglePageRoute) {
        document.documentElement.style.overflow = ""
        document.body.style.overflow = ""
      }
    }, 100)

    eventTracker.trackEvent({
      event: "app:print",
      data: {
        url: pathname,
      },
    })
  }

  // handle browser print shortcuts
  useEffect(() => {
    const handleBeforePrint = () => {
      const currentRoute = pathname.split("/")[1]
      const isSinglePageRoute = SINGLE_PAGE_ROUTES.includes(currentRoute)

      if (isSinglePageRoute) {
        document.documentElement.style.overflow = "hidden"
        document.body.style.overflow = "hidden"
      }
    }

    const handleAfterPrint = () => {
      const currentRoute = pathname.split("/")[1]
      const isSinglePageRoute = SINGLE_PAGE_ROUTES.includes(currentRoute)

      if (isSinglePageRoute) {
        document.documentElement.style.overflow = ""
        document.body.style.overflow = ""
      }
    }

    window.addEventListener("beforeprint", handleBeforePrint)
    window.addEventListener("afterprint", handleAfterPrint)

    return () => {
      window.removeEventListener("beforeprint", handleBeforePrint)
      window.removeEventListener("afterprint", handleAfterPrint)
    }
  }, [pathname])

  const isRouteVisible = ROUTES_SHOWN.includes(pathname.split("/")[1])

  return (
    <Button
      className={`${isRouteVisible ? "" : "invisible hidden"} print:hidden`}
      onClick={handlePrint}
      color="tertiary">
      <Printer />
    </Button>
  )
}
